import React, { forwardRef, useState } from 'react';
import { arrayOf, oneOfType, string, shape, bool } from 'prop-types';
import { Link } from 'react-router-dom';
import map from 'lodash/map';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import $ from 'jquery';
import plainify from '../../util/remove_html_markup';
import { ui, uiA, uiConnector } from 'envy-ui';

function Nav({ items, linkPrefix, navTextColor, forwardedRef={}, className= 'nav-menu-visible', horizontal=false }) {
  const toggleCollapse = ({ currentTarget }) => {
    $(currentTarget)
      .toggleClass('env-collapser-legacy--off')
      .closest('.first-level-title')
      .next('.second-level-content')
      .slideToggle(_, () => {
        if ($(currentTarget).attr('aria-expanded') == 'false') {
          $(currentTarget).attr('aria-expanded', 'true');
        } else {
          $(currentTarget).attr('aria-expanded', 'false');
        }
      });
  };
  const itemsShow = [];
  let itemsHide = [];
  let sliced = false;

  items.forEach(({ title, ...item }, itemIndex) => {
    if (!sliced) {
      if (map(itemsShow, 'title').join().length + title.length > 110) {
        itemsHide = [...itemsHide, ...items.slice(itemIndex)];
        sliced = true;
      } else {
        itemsShow.push({ title, ...item });
      }
    }
  });

  return (
    <nav className="env-nav" ref={forwardedRef}>
      <ul className={`nav-menu ${className}`}>
        {items.map(function builder(
          { id: to, title, items: subItems = [], measures = [], level, isMeasure, numberOfSiblings = 0, withCousins = false, parents = [] },
          itemIndex,
        ) {
          const connectors = [...parents];
          const isLast = ((isMeasure && !withCousins) || !isMeasure) && itemIndex === numberOfSiblings - 1;

          if (level > 1) {
            if (isLast) {
              connectors.push(uiConnector`--normal --light --l-top`);
            } else {
              connectors.push(uiConnector`--normal --light`);
            }
          }

          return (
            <li key={`nav-item-${to}`}>
              {(!measures.length && !subItems.length) /* || level >= 2 */ || isMeasure ? (
                <Link to={`${linkPrefix}/${to}`} {...ui([uiA`p-y-2`, 'nav-menu-link'])}>
                  {connectors.map((connector, connectorIndex) => (
                    <span
                      key={`connector-${connectorIndex}`}
                      {...ui([
                        connector,
                        uiA`h-100% w-min-10 m-right-small hide:${level === 1 && connectorIndex === connectors.length - 1}`,
                      ])}
                    />
                  ))}
                  {isMeasure && <FontAwesomeIcon icon={['fal', 'chart-bar']} />}
                  <span style={level === 1 ? { color: navTextColor } : {}}>{plainify(title)}</span>
                </Link>
              ) : (
                <div className="dropdown-content">
                  <div className="first-level-title">
                    <Link to={`${linkPrefix}/${to}`} {...ui([uiA`p-y-2`, 'nav-menu-link'])}>
                      {connectors.map((connector, connectorIndex) => (
                        <span
                          key={`connector-${connectorIndex}`}
                          {...ui([
                            connector,
                            uiA`h-100% w-min-10 m-right-small hide:${level === 1 && connectorIndex === connectors.length - 1}`,
                          ])}
                        />
                      ))}
                      <span style={level === 1 ? { color: navTextColor } : {}}>{plainify(title)}</span>
                    </Link>
                    <div className="nav-button-collapser-wrapper">
                      <button
                        className="env-collapser-legacy env-collapser-legacy--off"
                        onClick={toggleCollapse}
                        type="button"
                        aria-label="Submenu"
                        style={horizontal && level === 1 ? { color: navTextColor } : {}}
                        aria-expanded={false}
                      >
                        <FontAwesomeIcon icon={['fal', 'chevron-down']} size={`${horizontal ? 'xs' : '1x'}`} />
                      </button>
                    </div>
                  </div>
                  <ul className="second-level-content env-hide">
                    {measures
                      .map((measure) => ({
                        ...measure,
                        level: level + 1,
                        numberOfSiblings: measures.length,
                        withCousins: !!subItems.length,
                        parentIsLast: isLast,
                        parentLevel: level,
                        parents: [
                          ...parents,
                          ...(level > 1 ? [isLast ? uiConnector`--normal --light --hidden` : uiConnector`--normal --light --i`] : []),
                        ],
                      }))
                      .map(builder)}
                    {subItems
                      .map((planNode) => ({
                        ...planNode,
                        numberOfSiblings: subItems.length,
                        parentIsLast: isLast,
                        parentLevel: level,
                        parents: [
                          ...parents,
                          ...(level > 1 ? [isLast ? uiConnector`--normal --light --hidden` : uiConnector`--normal --light --i`] : []),
                        ],
                      }))
                      .map(builder)}
                  </ul>
                </div>
              )}
            </li>
          );
        })}
      </ul>
    </nav>
  );
}

Nav.propTypes = {
  items: arrayOf(shape({})).isRequired,
  linkPrefix: oneOfType([bool, string]).isRequired,
  navTextColor: string.isRequired,
  className: string,
  forwardedRef: shape({}),
  horizontal: bool,
};

export default forwardRef((props, ref) => <Nav {...props} forwardedRef={ref} />);
